(function () {
    'use strict';

    angular
        .module('HRConfirmationsControllers')
        .controller('HRConfirmationsInProgressController', Controller);

    Controller.$inject = ['$scope', '$interval', 'employeeSyncService'];

    function Controller($scope, $interval, employeeSyncService) {

        var INTERVAL_DELAY_IN_MS = 5000;
        var intervalPromise;

        // Get Latest Batch
        getLatestBatch()
         .then(function (latestBatch) {
             if ($scope.isSyncInProgress()) {
                 startInterval();
             }
         });

        // Show Sync In Progress Msg?
        $scope.isSyncInProgress = function () {
            if (_.isUndefined($scope.ctrlCtxt.latestBatch.PubEmp_BatchID)) return;

            return !$scope.ctrlCtxt.latestBatch.IsProcessed;
        };

        // Show Warning Box?
        $scope.showWarningBox = function () {
            if (_.isUndefined($scope.ctrlCtxt.latestBatch.PubEmp_BatchID)) return;

            return $scope.ctrlCtxt.latestBatch.PubEmp_BatchID !== $scope.ctrlCtxt.latestClosedBatch.PubEmp_BatchID;
        };

        // Refresh page
        $scope.refreshPage = function () {
            window.location.reload();
        };

        $scope.$on('$destroy', function () {
            // Make sure that the interval is destroyed too
            stopInterval();
        });

        function startInterval() {
            intervalPromise = $interval(function () {
                getLatestBatch()
                     .then(function (latestBatch) {
                         if (!$scope.isSyncInProgress()) {
                             stopInterval();
                         }
                     });
            }, INTERVAL_DELAY_IN_MS);
        }

        function stopInterval() {
            if (!_.isUndefined(intervalPromise)) {
                $interval.cancel(intervalPromise);
                intervalPromise = undefined;
            }
        }

        function getLatestBatch() {
            return employeeSyncService
                  .getLatestBatch()
                  .then(function (latestBatch) {
                      $scope.ctrlCtxt.latestBatch = latestBatch;

                      return latestBatch;
                  });
        }
    }
})();